import React from 'react'

const t = {
    FR: {
        specifics_todo: {'page title': `À faire`,},
        'for': 'du',
        'Unchangeable': 'Non-modifiable',
        'Back to active list': 'Retour à la liste active',
        'Back to list': 'Retour à la liste',
        'Your categories': 'Vos catégories',
        'New item': <>Nouvel item&nbsp;:</>,
        'New title': <>Nouveau titre&nbsp;:</>,
        'Add item': 'Ajouter un élément',
        'Edit item': 'Modifier un élément',
        'Delete item': 'Retirer un élément',
        'Delete category': 'Retirer une catégorie',
        'Manage categories': 'Gérer les catégories',
        'Item count 1': 'Cette catégorie contient',
        'Item count 2': 'éléments. Ils seront aussi supprimés.',

        'Log as public user': <>Connecter l'utilisateur public</>,
        'No password required, just one click': 'Aucun mot de passe requis, un seul clic!',
        'publicUser message': <div>
            <p>
                Sachez que vos modifications sont publiques. Ceci n'est qu'un démo.<br/>
                Créez-vous un compte pour une liste permanente et privée.
            </p>
            <p>
                Les modifications faites ici seront effacées sur déconnection.
            </p>
        </div>,
        'remainingSecondsText1': <>Vous avez</>,
        'remainingSecondsText2': <>restant.</>,

        'Select a history date': <>Selectionnez une date de l'historique</>,
        [`Save today's history`]: <>Sauvegarder l'historique d'aujourdhui</>,
        'History saved at': <>L'historique a été sauvegardé à</>,

        'todoItem 1': `Une vraie TODO list! Elle me permettra notamment de maintenir cette page.`,
        'todoItem 2': `Un budget personnel. J'ai une bonne méthode de contrôle de mon budget sur un tableau Excel et j'aimerais la partager  car, du moins pour moi, la méthode fonctionne à merveille. Il s'agira d'un module relativement complexe, composé de plusieurs  formulaires inter-dépendants et de rapports.`,
        'todoItem 3': `Une carte de temps pour enregistrer du temps passé à accomplir diverses tâches (par catégorie).`,
        'todoItem 4': `Et plus encore...`,
        'text 2': `Mais d'abord, je dois paufiner le système de connection, faire le module de profil, la fonction 'Supprimer mon compte'... Et plus de CSS!`,
        'todoItem 5': `Mais d'abord, je dois paufiner le système de connection`,
        'todoItem 6': `Faire le module de profil`,
        'todoItem 7': `Faire la fonction 'Supprimer mon compte'`,
    },
    EN: {
        specifics_todo: {'page title': `To do`,},
        'for': 'for',
        'Unchangeable': 'Unchangeable',
        'Back to active list': 'Back to active list',
        'Back to list': 'Back to list',
        'Your categories': 'Your categories',
        'New item': 'New item:',
        'New title': 'New title:',
        'Add item': 'Add item',
        'Edit item': 'Add item',
        'Delete item': 'Add item',
        'Delete category': 'Delete a category',
        'Manage categories': 'Manage categories',
        'Item count 1': 'This category contains',
        'Item count 2': 'items. They will also be deleted.',

        'Log as public user': 'Connect public user',
        'No password required, just one click': 'No password required, just one click!',
        'publicUser message': <div>
            <p>
                Please note that your edits are public. This is just a demo.<br/>
                Create an account for a permanent and private list.
            </p>
            <p>
                Changes made here will be erased upon logout.
            </p>
        </div>,
        'remainingSecondsText1': <>You have</>,

        'Select a history date': 'Select a history date',
        [`Save today's history`]: <>Save today's history</>,
        'History saved at': 'History saved at',

        'todoItem 1': `A real TODO list! It will allow me to maintain this page.`,
        'todoItem 2': `A personal budget. I have a good method for controlling my budget on an Excel spreadsheet and I would like to share it because, at least for me, the method works wonderfully. It will be a relatively complex module, composed of several interdependent forms and reports.`,
        'todoItem 3': `A time card to record time spent on various tasks (by category).`,
        'todoItem 4': `And more...`,
        'todoItem 5': `But first, I need to polish the login system`,
        'todoItem 6': `Make the profile module`,
        'todoItem 7': `Make the 'Delete my account' function`,
    },
    ES: {
        specifics_todo: {'page title': `Hacer`,},
        'for': 'para',
        'Unchangeable': 'No modificable',
        'Back to active list': 'Volver a la lista activa',
        'Back to list': 'Volver a la lista',
        'Your categories': 'Tus categorias',
        'New item': 'Nuevo artículo:',
        'New title': 'Nuevo título:',
        'Add item': 'Añadir artículo',
        'Edit item': 'Editar artículo',
        'Delete item': 'Eliminar elemento',
        'Delete category': 'Eliminar una categoría',
        'Manage categories': 'Administrar categorías',
        'Item count 1': 'Esta categoría contiene',
        'Item count 2': 'elementos. También serán eliminados.',

        'Log as public user': 'Conectar usuario público',
        'No password required, just one click': '¡No necesita contraseña, sólo un clic!',
        'publicUser message': <div>
            <p>
                Tenga en cuenta que sus ediciones son públicas. Esto es solo una demostración.<br/>
                Crea una cuenta para una lista permanente y privada.
            </p>
            <p>
                Los cambios realizados aquí se borrarán al cerrar la sesión.
            </p>
        </div>,
        'remainingSecondsText1': <>Tienes</>,

        'Select a history date': 'Seleccione una fecha del historial',
        [`Save today's history`]: <>Guarda la historia de hoy</>,
        'History saved at': 'Historial guardado en',

        'todoItem 1': `¡Una verdadera lista de TODOS! En particular, me permitirá mantener esta página.`,
        'todoItem 2': `Un presupuesto personal. Tengo un buen método para controlar mi presupuesto en una hoja de cálculo de Excel y me gustaría compartirlo porque, al menos a mí, el método funciona de maravilla. Este será un módulo relativamente complejo, que constará de varios formularios e informes interrelacionados.`,
        'todoItem 3': `Una tarjeta de tiempo para registrar el tiempo dedicado a completar diversas tareas (por categoría).`,
        'todoItem 4': `Y más...`,
        'todoItem 5': `Pero primero tengo que modificar el sistema de conexión`,
        'todoItem 6': `Crear el módulo de perfil`,
        'todoItem 7': `Crear la función 'Eliminar mi cuenta'`,
    },
    PT: {
        specifics_todo: {'page title': `Tarefas`,},
        'for': 'para',
        'Unchangeable': 'Não modificável',
        'Back to active list': 'Voltar para a lista ativa',
        'Back to list': 'Voltar para a lista',
        'Your categories': 'Suas categorias',
        'New item': 'Novo item:',
        'New title': 'Novo título:',
        'Add item': 'Adicionar item',
        'Edit item': 'Editar item',
        'Delete item': 'Excluir item',
        'Delete category': 'Excluir uma categoria',
        'Manage categories': 'Gerenciar categorias',
        'Item count 1': 'Esta categoria contém',
        'Item count 2': 'itens. Eles também serão deletados.',

        'Log as public user': 'Conectar usuário público',
        'No password required, just one click': 'Não é necessária senha, apenas um clique!',
        'publicUser message': <div>
            <p>
                Observe que suas edições são públicas. Esta é apenas uma demonstração.<br/>
                Crie uma conta para uma lista permanente e privada.
            </p>
            <p>
                As alterações feitas aqui serão apagadas após o logout.
            </p>
        </div>,
        'remainingSecondsText1': <>Você tem</>,

        'Select a history date': 'Selecione uma data histórica',
        [`Save today's history`]: <>Salve a história de hoje</>,
        'History saved at': 'Histórico salvo em',

        'todoItem 1': `Uma verdadeira lista de TAREFAS! Ela me permitirá manter esta página.`,
        'todoItem 2': `Um orçamento pessoal. Tenho um bom método para controlar meu orçamento em uma planilha do Excel e gostaria de compartilhá-lo porque, pelo menos para mim, o método funciona maravilhosamente bem. Será um módulo relativamente complexo, composto por vários formulários e relatórios interdependentes.`,
        'todoItem 3': `Um cartão de ponto para registrar o tempo gasto em várias tarefas (por categoria).`,
        'todoItem 4': `E mais...`,
        'todoItem 5': `Mas primeiro, preciso aprimorar o sistema de login`,
        'todoItem 6': `Criar o módulo de perfil`,
        'todoItem 7': `Criar a função 'Excluir minha conta'`,
    },
}

export default t